/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getLoginDetails} from '../api'

 export const useQueryGetLoginDetails = createReactQueryHook('getLoginDetails', getLoginDetails)
